import React, { useEffect, useState } from 'react'
import { useDrag } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import { Resizable } from 'react-resizable'
import Box from './Box'
import { ItemTypes } from './utils/ItemTypes'
import 'react-resizable/css/styles.css'
import './DragAndDrop.module.scss'

function getStyles(left, top, spacing, color, isDragging) {
  const transform = `translate3d(${left}px, ${top}px, 0)`

  return {
    position: 'absolute',
    transform,
    color,
    letterSpacing: spacing,
    WebkitTransform: transform,
    // IE fallback: hide the real node using CSS when dragging
    // because IE will ignore our custom "empty image" drag preview.
    opacity: isDragging ? 0 : 1
  }
}

export default function DraggableBox({ id, label, left, top, width, height, spacing, color, fontName,
                                       wrap, align, textSize, object, sampleText, personalizationBoxUrl, text, columnType, onResize, hideBoundingBoxes }) {
  const [size, setSize] = useState({ width: width || 100, height: height || 30 })

  // Sync size with props when they change externally
  useEffect(() => {
    setSize({ width: width || 100, height: height || 30 })
  }, [width, height])

  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: ItemTypes.BOX,
      item: { id, left, top, label, width: size.width, height: size.height, object, wrap },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [id, left, top, size.width, size.height, label, spacing, color, fontName, object, wrap],
  )

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [])

  const handleResize = (event, { size: newSize }) => {
    setSize({ width: newSize.width, height: newSize.height })
  }

  const handleResizeStop = (event, { size: newSize }) => {
    // Save to server
    if (object) {
      object.width = newSize.width
      object.height = newSize.height
      object.save().then(() => {
        if (onResize) {
          onResize(id, newSize.width, newSize.height)
        }
      })
    }
  }

  return (
    <div
      ref={drag}
      style={getStyles(left, top, spacing, color, isDragging)}
      role="DraggableBox"
    >
      <Resizable
        width={size.width}
        height={size.height}
        onResize={handleResize}
        onResizeStop={handleResizeStop}
        minConstraints={[30, 15]}
        handleSize={[8, 8]}
        resizeHandles={hideBoundingBoxes ? [] : ['se', 'e', 's']}
      >
        <div style={{ width: size.width, height: size.height }}>
          <Box
            title={label}
            align={align}
            textSize={textSize}
            font={fontName}
            sampleText={sampleText}
            personalizationBoxUrl={personalizationBoxUrl}
            text={text}
            columnType={columnType}
            hideBoundingBoxes={hideBoundingBoxes}
          />
        </div>
      </Resizable>
    </div>
  )
}
